import { render, staticRenderFns } from "./EditorIcon.vue?vue&type=template&id=7d79f1d4&"
import script from "./EditorIcon.vue?vue&type=script&lang=js&"
export * from "./EditorIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports